import React from 'react';
import styled from 'styled-components';

import Tag from '../Tag';

export const BaseTag = styled(Tag)`
  margin: 2px 8px 2px 0px;
`;
